import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import {
  QueryClient,
  QueryClientProvider,
  MutationCache,
} from "@tanstack/react-query";
import { toast } from "sonner";
import App from "./App";
import "./index.css";
import {
  getMutationSuccessMessage,
  getErrorMessage,
} from "./lib/notifications";

const mutationCache = new MutationCache({
  onError: (error) => {
    const message = getErrorMessage(error);
    toast.error(message);
  },
  onSuccess: (_data, _variables, _context, mutation) => {
    // Get the mutation key if provided
    const key = mutation.options.mutationKey?.[0] as string | undefined;
    if (key) {
      const message = getMutationSuccessMessage(key);
      if (message) {
        toast.success(message);
      }
    }
  },
});

const queryClient = new QueryClient({
  mutationCache,
  defaultOptions: {
    queries: {
      staleTime: 0, // Always consider data stale - refetch on every mount
      retry: 1,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
